export default function TestDocumentController(
  $q,
  $rootScope,
  alerts,
  bcpDataService,
  confirmDialog,
  ssDialogService,
  editTestDocumentDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleEditTestDocument = _handleEditTestDocument;
  vm.handleDeleteTestDocument = _handleDeleteTestDocument;

  /** *********************************
   * Event Handlers
   */
  function _handleEditTestDocument($event) {
    return bcpDataService.getTest(vm.testDocument.assessmentTestId).then((response) => {
      const assessmentTest = response.data;
      ssDialogService.dialogs.bcp.editTestDocumentDialog = ssDialogService.alert(
        editTestDocumentDialog.getOptions($event, {
          assessmentId: vm.assessmentId,
          test: assessmentTest,
          testDocument: vm.testDocument,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.editTestDocumentDialog);
    });
  }

  function _handleDeleteTestDocument($event) {
    ssDialogService.dialogs.bcp.confirmDeleteTestDocumentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Test Document?',
        message: `Are you sure you want to delete the Test Document "${vm.testDocument.displayValue}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteTestDocumentDialog);
  }

  /** *********************************
   * Private Functions
   */

  function _handleConfirmDelete($event) {
    return bcpDataService.deleteTestDocument(vm.testDocument.assessmentTestDocumentId)
      .then(() => {
        alerts.success('The Test Document has been deleted successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        $rootScope.$broadcast('refreshBCPTestDocument');
        _closeDeleteDialog($event);
      }).catch(() => {
        alerts.error('An error occurred deleting the test document.');
      });
  }

  function _closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteTestDocumentDialog);
  }

  function _handleCancelDelete($event) {
    return _closeDeleteDialog($event);
  }
}

TestDocumentController.$inject = [
  '$q',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'confirmDialog',
  'ssDialogService',
  'editTestDocumentDialog'
];
